module.exports = __webpack_public_path__ + "media/images/visa_logo-c01c3283a3a9f23b91c8df8c0060fa64.png";